<template>
  <div>
    <b-card class="sa-card sa-page-dashboard-card-body-chart" style="height: 100%" :header="'Filtri'" header-tag="header" footer-tag="footer" title="">
      <b-card-header>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Modalità Visualizzazione" v-slot="{ ariaDescribedby }">
              <b-form-radio-group v-model="filtro.riferimento" :options="options" :aria-describedby="ariaDescribedby" name="Modalita Visualizzazione" plain></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <div style="display: flex; margin-top: 25px">
              <font-awesome-icon icon="arrow-circle-left" :disabled="disabledTrimestre" style="height: 28px; width: 28px; justify-content: start; margin-right: 2px; cursor: pointer" @click="indietro()" />
              <b-form-input class="text-center" :value="getFiltroDescription()" :disabled="true"></b-form-input>
              <font-awesome-icon icon="arrow-circle-right" :disabled="disabledTrimestre" style="height: 28px; width: 28px; margin-left: 2px; cursor: pointer" @click="avanti()" />
            </div>
          </b-col>
          <b-col cols="2">
            <label class="sa-label-data">Data Dal</label>
            <date-picker format="DD/MM/YYYY" :disabled="disabledFiltroDalAl" @input="loadData()" value-type="timestamp" v-model="filtro.dataDal" type="date"></date-picker>
          </b-col>
          <b-col cols="2">
            <label class="sa-label-data">Data Al</label>
            <date-picker format="DD/MM/YYYY" :disabled="disabledFiltroDalAl" @input="loadData()" value-type="timestamp" v-model="filtro.dataAl" type="date"></date-picker>
          </b-col>
        </b-row>
      </b-card-header>
    </b-card>
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table"> </b-table>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <data-analysis-chart-view-component :chartParams="chartParams" ref="cmpDataAnalysisChartViewComponent" @updateChart="onUpdateChart"></data-analysis-chart-view-component>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DataAnalysisChartViewComponent from "../../../dataanalysis/components/DataAnalysisChartViewComponent.vue";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";
import moment from "moment";
export default {
  components: { DataAnalysisChartViewComponent, DatePicker },
  mixin: [UtilityMixin],
  data() {
    return {
      dataRiferimento: new Date(),
      rows: 0,
      perPage: 50,
      currentPage: 1,
      pathResource: "/rsaattivitapazienteobiettivo/riepilogo",
      disabledFiltroDalAl: true,
      disabledTrimestre: false,
      chartParams: { title: "Obiettivo Attività", type: "graphic", staticData: true },
      anno: {
        dataDal: null,
        dataAl: null,
      },
      trimestri: {
        1: { dataDal: null, dataAl: null },
        2: { dataDal: null, dataAl: null },
        3: { dataDal: null, dataAl: null },
        4: { dataDal: null, dataAl: null },
      },
      options: [
        { text: "Trimestre", value: "T" },
        { text: "Annuale", value: "A" },
        { text: "Periodo", value: "P" },
      ],
      filtro: {
        riferimento: "T",
        dataDal: new Date().getTime(),
        dataAl: new Date().getTime(),
        trimestre: 1,
        anno: 2025,
      },
      items: [],
      fields: [
        {
          label: "Attività",
          key: "nomAttivita",
          sortable: true,
        },
        {
          label: "Durata",
          key: "durata",
          sortable: true,
          thStyle: "width: 5rem",
        },
        {
          label: "Obiettivo",
          key: "obiettivo",
          sortable: true,
          thStyle: "width: 5rem",
        },
        {
          label: "Cons.",
          key: "punteggio",
          sortable: true,
          thStyle: "width: 5rem",
        },
        {
          label: "Risultato",
          key: "risultato",
          sortable: true,
          thStyle: "width: 5rem",
        },
      ],
    };
  },
  watch: {
    "filtro.riferimento": function () {
      this.setFilter();
    },
  },
  mounted() {
    this.setTrimestri();
    this.setAnnoRicerca();
    this.setFilter();
    this.loadData();
    this.createChart();
  },
  methods: {
    defaultLoading() {
      this.setTrimestri();
      this.setAnnoRicerca();
      this.setFilter();
      this.loadData();
      this.createChart();
    },
    loadData() {
      let me = this;
      let idAccettazione = this.$route.query.idAccettazione;
      this.filtro.idAccettazione = idAccettazione;

      let dataAl = this.filtro.dataAl;
      let dataDal = this.filtro.dataDal;
      me.items = [];
      UtilityMixin.methods.loadDataResources(me.pathResource, { idAccettazione: idAccettazione, dataAl: dataAl, dataDal: dataDal }, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      me.items = response.data.data;
      this.createChart();
    },
    loadDataError(error) {
      console.log(error);
    },
    setFilter() {
      if ("T" == this.filtro.riferimento) {
        this.disabledTrimestre = false;
        this.disabledFiltroDalAl = true;
        this.filtro.dataAl = this.trimestri[this.getTrimestre()].dataAl;
        this.filtro.dataDal = this.trimestri[this.getTrimestre()].dataDal;
      } else if ("P" == this.filtro.riferimento) {
        this.disabledFiltroDalAl = false;
        this.filtro.dataAl = new Date().getTime();
        this.filtro.dataDal = new Date().getTime();
      } else if ("A" == this.filtro.riferimento) {
        this.disabledFiltroDalAl = true;
        this.filtro.dataAl = this.anno.dataAl;
        this.filtro.dataDal = this.anno.dataDal;
      }
    },
    avanti() {
      let me = this;

      if ("P" == me.filtro.riferimento) {
        return;
      }

      if ("T" == me.filtro.riferimento) {
        me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() + 90));
        this.setTrimestri();
        this.setFilter();
      } else if ("A" == me.filtro.riferimento) {
        me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() + 365));
        this.setAnnoRicerca();
        this.setFilter();
      }
      this.loadData();
    },
    indietro() {
      let me = this;
      if ("P" == me.filtro.riferimento) {
        return;
      }
      if ("T" == me.filtro.riferimento) {
        me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() - 90));
        this.setTrimestri();
        this.setFilter();
      } else if ("A" == me.filtro.riferimento) {
        me.dataRiferimento = new Date(me.dataRiferimento.setDate(me.dataRiferimento.getDate() - 365));
        this.setAnnoRicerca();
        this.setFilter();
      }
      this.loadData();
    },
    getFiltroDescription() {
      let me = this;
      let esito = "";
      if ("T" == me.filtro.riferimento) {
        esito = this.getAnno(me.dataRiferimento) + "/" + this.getTrimestre(me.dataRiferimento);
      } else if ("P" == me.filtro.riferimento) {
        esito = "";
      } else if ("A" == me.filtro.riferimento) {
        esito = this.getAnno(me.dataRiferimento);
      }
      return esito;
    },
    getTrimestre() {
      return moment(this.dataRiferimento).quarter();
    },

    setTrimestri() {
      let annoRiferimento = this.dataRiferimento.getFullYear();
      for (let t = 1; t <= 4; t++) {
        let inizioTrimestre = moment.utc().year(annoRiferimento).quarter(t).startOf("quarter").set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        let fineTrimestre = moment().year(annoRiferimento).quarter(t).endOf("quarter").set({ hour: 23, minute: 59, second: 59, millisecond: 0 });
        this.trimestri[t].dataDal = inizioTrimestre.valueOf();
        this.trimestri[t].dataAl = fineTrimestre.valueOf();
      }
    },
    setAnnoRicerca() {
      let annoRiferimento = this.dataRiferimento.getFullYear();
      let inizioAnno = moment.utc().year(annoRiferimento).month(0).date(1).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });

      let fineAnno = moment().year(annoRiferimento).month(11).date(31).set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 0,
      });
      this.anno.dataDal = inizioAnno.valueOf();
      this.anno.dataAl = fineAnno.valueOf();
    },
    getAnno(data) {
      return data.getFullYear();
    },
    createChart() {
      let me = this;
      let xAxis = [];
      let seriesDataUno = [];
      let seriesDataDue = [];
      this.items.forEach((element) => {
        xAxis.push(element.codiceAttivita);
        seriesDataUno.push(element.obiettivo);
        seriesDataDue.push(element.punteggio);
      });
      this.chartParams.chartData = {
        legend: true,
        xAxis: [
          {
            type: "category",
            offset: 0,
            axisTick: { show: false },
            axisLabel: {
              show: true,
              interval: 0,
              rotate: 0,
              overflow: "break",
              //fontSize: "10px",
              formatter: function (v) {
                let x = me.items.filter((element) => element.codiceAttivita === v);
                if (x[0].obiettivo === x[0].punteggio) {
                  return `{si|${v}}`;
                } else {
                  return `{no|${v}}`;
                }
                //return v;
              },
              rich: {
                si: {
                  color: "#00AA33",
                  fontWeight: "bold",
                },
                no: {
                  color: "#AA0033",
                  fontWeight: "bold",
                },
              },
            },
            data: xAxis, // ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },
        ],
        yAxis: {
          max: 100,
          type: "value",
        },
        series: [
          {
            name: "Obiettivo",
            data: seriesDataUno,
            type: "bar",
          },
          {
            name: "Prestazione",
            data: seriesDataDue,
            type: "bar",
          },
        ],
      };
      this.$refs.cmpDataAnalysisChartViewComponent.setStaticChartData(this.chartParams);
    },
    onUpdateChart() {},
  },
};
</script>

<style></style>
